import React from 'react';
import { motion } from 'framer-motion';
import { User, KeyRound, Check, Copy } from 'lucide-react';
import { DjayAvatar } from '../../../mascot';
import { ConfettiCelebration } from '../ConfettiCelebration';
type Role = 'learner' | 'parent' | 'teacher';
interface RegisterSuccessStepProps {
  role: Role;
  name: string;
  generatedUsername: string;
  generatedLinkCode: string;
  onCopyLinkCode: () => void;
  copied: boolean;
}
export function RegisterSuccessStep({
  role,
  name,
  generatedUsername,
  generatedLinkCode,
  onCopyLinkCode,
  copied
}: RegisterSuccessStepProps) {
  return <motion.div key="step-success" initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.4
  }} className="text-center py-4 relative" data-id="element-494">
      <ConfettiCelebration data-id="element-495" />

      <motion.h2 className="text-2xl font-black text-slate-900 mb-2" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} data-id="element-496">
        Welkom bij Meester djay! 🎉
      </motion.h2>

      {role === 'learner' ? <motion.div className="space-y-4" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.45
    }} data-id="element-497">
          <p className="text-slate-600 font-medium" data-id="element-498">
            Bewaar deze gegevens goed:
          </p>
          <div className="bg-orange-50 border border-orange-100 rounded-2xl p-4 text-left space-y-3" data-id="element-499">
            <div className="flex items-center gap-3 bg-white p-3 rounded-xl border border-orange-100" data-id="element-500">
              <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center text-orange-500 flex-shrink-0" data-id="element-501">
                <User className="w-5 h-5" data-id="element-502" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-503">
                <div className="text-[10px] font-bold text-orange-400 uppercase tracking-wider mb-0.5" data-id="element-504">
                  Gebruikersnaam
                </div>
                <div className="font-mono font-bold text-lg text-orange-900 truncate" data-id="element-505">
                  {generatedUsername}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white p-3 rounded-xl border border-orange-100" data-id="element-506">
              <div className="w-10 h-10 rounded-lg bg-orange-100 flex items-center justify-center text-orange-500 flex-shrink-0" data-id="element-507">
                <KeyRound className="w-5 h-5" data-id="element-508" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-509">
                <div className="text-[10px] font-bold text-orange-400 uppercase tracking-wider mb-0.5" data-id="element-510">
                  Koppelcode
                </div>
                <div className="font-mono font-black text-xl tracking-[0.2em] text-orange-900 truncate" data-id="element-511">
                  {generatedLinkCode}
                </div>
              </div>
              <button onClick={onCopyLinkCode} className="p-2 rounded-lg hover:bg-orange-50 text-orange-500 transition-colors flex-shrink-0" title="Kopieer code" data-id="element-512">
                {copied ? <Check className="w-5 h-5 text-emerald-500" data-id="element-513" /> : <Copy className="w-5 h-5" data-id="element-514" />}
              </button>
            </div>
            <p className="text-xs text-orange-600 mt-2 font-medium text-center" data-id="element-515">
              💡 Deel deze code met je ouder(s) of docent!
            </p>
          </div>
          <p className="text-sm text-slate-400 font-medium animate-pulse" data-id="element-516">
            Je wordt zo ingelogd...
          </p>
        </motion.div> : role === 'teacher' ? <motion.div className="space-y-4" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.45
    }} data-id="element-517">
          <p className="text-slate-600 font-medium" data-id="element-518">
            Welkom, meester/juf! Je docentaccount is klaar.
          </p>
          <div className="bg-indigo-50 border border-indigo-100 rounded-2xl p-4" data-id="element-519">
            <p className="text-sm text-indigo-800 font-medium" data-id="element-520">
              In het docentportaal kun je leerlingen toevoegen aan je klas.
            </p>
          </div>
          <p className="text-sm text-slate-400 font-medium animate-pulse" data-id="element-521">
            Naar je dashboard...
          </p>
        </motion.div> : <motion.div className="space-y-4" initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.45
    }} data-id="element-522">
          <p className="text-slate-600 font-medium" data-id="element-523">
            Welkom! Je ouderaccount is aangemaakt.
          </p>
          <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-4" data-id="element-524">
            <p className="text-sm text-emerald-800 font-medium" data-id="element-525">
              Koppel je kind(eren) met hun 6-cijferige koppelcode.
            </p>
          </div>
          <p className="text-sm text-slate-400 font-medium animate-pulse" data-id="element-526">
            Naar het ouderportaal...
          </p>
        </motion.div>}
    </motion.div>;
}